const getColorFromSoluto = (color) => {
    return `hsl(var(--soluto-${color}))`;
};

export { getColorFromSoluto };
